import { render, staticRenderFns } from "./BundlePackageList.vue?vue&type=template&id=25f45df2&"
import script from "./BundlePackageList.vue?vue&type=script&lang=js&"
export * from "./BundlePackageList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports